import { ContextFilters } from '../../../types/context/ContextFilters'

const dimensionQueryKeys = {
  all: [{ scope: 'dimension' }] as const,
  lists: () => [{ ...dimensionQueryKeys.all[0], entity: 'list' }] as const,
  list: (context: { companyId?: string | null }) => [{ ...dimensionQueryKeys.lists()[0], ...context }] as const,
  details: () => [{ ...dimensionQueryKeys.all[0], entity: 'detail' }] as const,
  detail: (context: Pick<ContextFilters, 'companyId'>, id: number) =>
    [{ ...dimensionQueryKeys.details()[0], ...context, id }] as const,
  undos: () => [{ ...dimensionQueryKeys.all[0], entity: 'undo' }] as const,
  undo: (context: { companyId: string }) => [{ ...dimensionQueryKeys.undos()[0], ...context }] as const
}

export default dimensionQueryKeys
